<template>
  <div class="footer-component">
    <div class="column_1">
      <div>
        <h6>Subscribe</h6>
        <iframe :src="baseAPI + '/webform/subscribe/share'" title="Subscribe | EKDIPA" class="webform-share-iframe" frameborder="0" allow="geolocation; microphone; camera" allowtransparency="true" allowfullscreen="true" style="width:100%;height:170px;border:none"></iframe>
      </div>
      <div class="partner-div">
        <h6>Partners</h6>
        <div class="logo-grid">
          <a href="http://nid.fmiti.gov.ng/" target="_blank"><img src="../assets/fmiti.png" height="50px"/></a>
          <a href="https://easeofdoingbusinessnigeria.com/" target="_blank"><img src="../assets/pebec-logo.png" height="50px"/></a>
          <a href="https://nipc.gov.ng/" target="_blank"><img src="../assets/nipc-logo.png" height="50px"/></a>
          <!-- <img src="../assets/usaid.png" height="50px"> -->
        </div>
      </div>
      <p>Copyright &copy; {{ year }}. All Rights Reserved.</p>
    </div>
    <div class="browse-footer">
      <h6>Browse</h6>
      <ul>
        <li><router-link to="/ease-of-business">Ease of Doing Business</router-link></li>
        <li><router-link to="/business-in-ekiti">Doing Business in Ekiti</router-link></li>
        <li><router-link to="/profile/overview">About EKDIPA</router-link></li>
        <li><router-link to="/profile/board-of-management">Our Board</router-link></li>
        <li><router-link to="/media">Media</router-link></li>
        <li><router-link to="/downloads">More</router-link></li>
      </ul>
    </div>
    <div class="contact-footer">
      <h6>Contact Us</h6>
      <div v-html="contentBody">
        <!-- EKDIPA<br />
			Ekiti Development and Investment Promotion Agency<br />
			Government Office Road<br />
			Ado-Ekiti, Ekiti, Nigeria -->
      </div>
    </div>

    <!-- <a href="#" target="_blank"><i class="fab fa-twitter"></i></a> 
  	<a href="#" target="_blank"><i class="fab fa-facebook"></i></a> 
    <a href="#" target="_blank"><i class="fab fa-linkedin"></i></a> -->
  </div>
</template>
<script>
import { mapState } from "vuex"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  data: function() {
    return {
      year: null,
      form: {},
      hasError: {},
      contentBody: null,
    }
  },
  methods: {
    async getNode(id) {
      // var id = "2"
      const { data } = await ContentRepository.getNode(id)
      // console.log('home page data', data)

      this.contentBody = data.body && data.body[0] && data.body[0].value ? data.body[0].value : null

      // this.getSiblings()
    },
  },
  computed: {
    ...mapState(["baseAPI"]),
  },

  mounted() {
    var d = new Date()
    this.year = d.getFullYear()

    this.getNode(84)
  },
}
</script>
<style>
.footer-component {
  display: grid;
  grid-template-columns: 6fr 3fr 3fr;
  text-align: left;
  grid-gap: 25px;
}

.logo-grid img {
  margin-right: 15px;
}

.browse-footer,
.contact-footer {
  border-left: 1px solid #e1e1e1;
  padding-left: 10%;
  padding-right: 10%;
}

.logo-grid {
  margin-bottom: 25px;
}

.footer-component div {
  xborder: 1px solid red;
}

.footer-component h6 {
  text-transform: uppercase;
}

.footer-component a {
  margin: 0;
}

.subscribe-grid {
  display: grid;
  grid-template-columns: 3fr 1fr;
}

.column_1 {
  padding-left: 5%;
  padding-right: 5%;
}

.partner-div {
  margin-top: -50px;
  padding-top: 30px;
  border-top: 1px solid #e1e1e1;
}

.contact-footer p {
  font-size: 11.5pt;
}
</style>
